import { useDispatch, useSelector } from 'react-redux'
import { stopAsyncValidation } from 'redux-form'
import { useState } from 'react'
import {
  actionCalculate,
  actionCalculateAccountMarket,
  actionCalculateAccounts,
  actionCalculateFee,
  actionDepositCreationFee,
  actionGetAccountData,
  actionGetCalculateAccountMarketMethods,
  actionGetNetworkAccountData,
  actionGetPaymentMethods,
  actionOrderAccountMarket,
  actionResetData,
  actionSetActiveMethod,
  actionTopUp,
  actionPushMethods,
} from 'modules/Forms/Billing/actions'
import { useCancelToken } from 'utils/hooks/useCancelToken'

export const useBilling = (formName = 'billing') => {
  const { billing, values } = useSelector(({ billing = {}, form = {} }) => ({
    billing,
    // redux-form state по названию формы
    values: form?.[formName]?.values || {},
  }))

  const [topUpProgress, setTopUpProgress] = useState(false)
  const [topUpFinished, setTopUpFinished] = useState(false)
  const [calculateProgress, setCalculateProgress] = useState(false)
  const [calculateFinished, setCalculateFinished] = useState(false)

  const dispatch = useDispatch()
  const { cancelableDispatch, cancelPreviousRequest } = useCancelToken()

  const setActiveMethod = (props) => dispatch(actionSetActiveMethod(props))

  const calculate = (props) => {
    let calculateAction

    switch (formName) {
      case 'billing':
      case 'accounts-billing':
        calculateAction =
          props?.accounts?.length > 0
            ? actionCalculateAccounts
            : actionCalculate
        break
      case 'deposit_creation_fee':
        calculateAction = actionCalculateFee
        break
      case 'account-marketplace':
        calculateAction = actionCalculateAccountMarket
        break
    }

    dispatch(stopAsyncValidation(formName, { clear: true }))
    cancelPreviousRequest()

    return new Promise((resolve, reject) => {
      setCalculateProgress(true)
      setCalculateFinished(false)

      cancelableDispatch(
        calculateAction({ ...props, meta: { resolve, reject } }),
      )
    }).finally(() => {
      setCalculateProgress(false)
      setCalculateFinished(true)
    })
  }

  calculate.progress = calculateProgress
  calculate.finished = calculateFinished

  const resetData = () => dispatch(actionResetData())

  const topUp = (props) => {
    let topUpAction

    switch (formName) {
      case 'billing':
      case 'accounts-billing':
        topUpAction = actionTopUp
        break
      case 'deposit_creation_fee':
        topUpAction = actionDepositCreationFee
        break
      case 'account-marketplace':
        topUpAction = actionOrderAccountMarket
        break
    }

    return new Promise((resolve, reject) => {
      setTopUpProgress(true)
      setTopUpFinished(false)
      dispatch(topUpAction({ ...props, meta: { resolve, reject } }))
    }).finally(() => {
      setTopUpProgress(false)
      setTopUpFinished(true)
    })
  }

  topUp.progress = topUpProgress
  topUp.finished = topUpFinished

  const getPaymentMethods = (props) => {
    let action

    switch (formName) {
      case 'account-marketplace':
        action = actionGetCalculateAccountMarketMethods
        break
      default:
        action = actionGetPaymentMethods
        break
    }

    cancelableDispatch(action(props))
  }

  const getAccountData = (props) => dispatch(actionGetAccountData(props))

  const getNetworkAccountData = (props) =>
    dispatch(actionGetNetworkAccountData(props))

  const pushMethods = (props) => dispatch(actionPushMethods(props))

  return {
    calculate,
    topUp,
    setActiveMethod,
    resetData,
    getPaymentMethods,
    getAccountData,
    getNetworkAccountData,
    pushMethods,
    data: billing,
    values,
  }
}
